// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.
import Vue from 'vue'
import BaseLayout from '@/js/components/Layout/BaseLayout.vue'
import PageContent from '@/js/components/PageContent.vue'
import SingleElementContent from '@/js/components/SingleElementContent.vue'
import TopNavigation from '@/js/components/Navigation/TopNavigation.vue'
import MinimalNavigation from '@/js/components/Navigation/MinimalNavigation.vue'
import NavigationDrawer from '@/js/components/Navigation/NavigationDrawer.vue'
import FooterNavigation from '@/js/components/Navigation/FooterNavigation.vue'
import QuickfinderMenu from '@/js/components/Quickfinder/QuickfinderMenu.vue'

import BuAppConfig from '@/js/components/AppConfig/BuAppConfig.vue'
import BuDealerBrands from '@/js/components/DealerBrands/BuDealerBrands.vue'
// import BuProductSearch from '@/js/components/Search/BuProductSearch.vue'

import BackgroundElement from '@/js/components/ContentElement/Elements/BackgroundElement.vue'

import BuHelpForm from '@/js/components/Help/BuHelpForm.vue'

/** TODO: Remove after using the content element component */
import ComplaintFormTicketSelect from '@/js/components/Forms/ComplaintForm/ComplaintFormTicketSelect.vue'
import ComplaintForm from '@/js/components/Forms/ComplaintForm/ComplaintForm.vue'
import ContactForm from '@/js/components/Contact/ContactForm.vue'
// import DpLogin from '@/js/components/ContentElement/Elements/DpLogin.vue'
import LoginForm from '@/js/components/Login/LoginForm.vue'
const isPrototype = 'pondp2020IsPrototype' in window && window.pondp2020IsPrototype

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context('./Base', false, /Base[A-Z].+\.(js|vue)/)

// For each matching file name...
requireComponent.keys().forEach(fileName => {
  // Get the component config
  const component = requireComponent(fileName)
  const componentConfig = component.default || component

  // Get the PascalCase version of the component name
  const componentName = componentConfig.name || fileName.replace(/^.+\//, '').replace(/\.\w+$/, '')

  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.component('BaseLayout', BaseLayout)
Vue.component('PageContent', PageContent)
Vue.component('SingleElementContent', SingleElementContent)
Vue.component('TopNavigation', TopNavigation)
Vue.component('MinimalNavigation', MinimalNavigation)
Vue.component('NavigationDrawer', NavigationDrawer)
Vue.component('FooterNavigation', FooterNavigation)
Vue.component('QuickfinderMenu', QuickfinderMenu)

Vue.component('BuAppConfig', BuAppConfig)
Vue.component('BuDealerBrands', BuDealerBrands)
// Vue.component('BuProductSearch', BuProductSearch)

Vue.component('BackgroundElement', BackgroundElement)

Vue.component('BuHelpForm', BuHelpForm)
Vue.component('LoginForm', LoginForm)

/** TODO: Remove after using the content element component */
Vue.component('ContactForm', ContactForm)
Vue.component('ComplaintFormTicketSelect', ComplaintFormTicketSelect)
Vue.component('ComplaintForm', ComplaintForm)

// eslint-disable-next-line spaced-comment
////////////////////
//////////////////
/////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
///
/////////////////////////////////////////////
///////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////
//////
///
/////////////////////////////////////////////////
///////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////
///
///////////////////////////////////////////////
///////////
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////
///
 
//////////////////////////////////////////
//////////
